<template>
  <div class="customer-history">
    <div v-if="!customerPhone && !customerName" class="text-center p-5">
      <p class="text-muted">
        Khách hàng chưa có số điện thoại hoặc tên để tra cứu hóa đơn.
      </p>
    </div>

    <template v-else>
      <!-- Date & Type Filters -->
      <b-row class="mb-4 align-items-end">
        <b-col md="3" sm="5">
          <label class="small text-muted font-weight-bold">Từ ngày</label>
          <date-picker
            placeholder="Chọn ngày bắt đầu"
            class="form-control form-control-sm"
            :config="datePickerConfig"
            v-model="filters.fromDate"
          ></date-picker>
        </b-col>
        <b-col md="3" sm="5">
          <label class="small text-muted font-weight-bold">Đến ngày</label>
          <date-picker
            placeholder="Chọn ngày kết thúc"
            class="form-control form-control-sm"
            :config="datePickerConfig"
            v-model="filters.toDate"
          ></date-picker>
        </b-col>
        <b-col md="3" sm="5">
          <label class="small text-muted font-weight-bold">Loại hóa đơn</label>
          <b-form-select
            v-model="filters.type"
            :options="billTypeOptions"
            size="sm"
            class="form-control form-control-sm"
          ></b-form-select>
        </b-col>
        <b-col md="3" sm="7">
          <b-button
            variant="primary"
            size="sm"
            @click="onApplyFilter"
            class="font-weight-bolder"
          >
            <i class="fas fa-search mr-1"></i> Lọc
          </b-button>
          <b-button
            variant="secondary"
            size="sm"
            @click="onResetFilter"
            class="ml-2"
          >
            Làm mới
          </b-button>
        </b-col>
      </b-row>

      <div class="list-bill">
        <table class="table table-bordered-list table-hover col-md-12">
          <thead>
            <tr>
              <th class="text-center tdCode">ID</th>
              <th class="text-center tdProductName">Sản phẩm</th>
              <th class="text-center tdProductPrice">Giá</th>
              <th class="text-center tdQuantity">SL</th>
              <th class="text-center tdDiscountItem">C.Khấu</th>
              <th class="text-center tdTotalAmount">Tổng tiền</th>
              <th class="text-center tdTotalPayment">Thanh toán</th>
              <th class="text-center tdNote">Ghi chú</th>
            </tr>
          </thead>
          <tbody v-if="!isLoading && items.length > 0">
            <template v-for="(bill, i) in items">
              <tr
                :key="'h-' + bill.id + '-' + i"
                @mouseenter="hoveredBillId = bill.id"
                @mouseleave="hoveredBillId = null"
                :class="{ 'tr-rowspan-hover': hoveredBillId === bill.id }"
                :data="`row_${bill.billNumber}`"
              >
                <td
                  colspan="6"
                  style="
                    padding: 5px !important;
                    border-bottom: none !important;
                  "
                >
                  <div class="d-flex align-items-start">
                    <div class="flex-grow-1">
                      <div class="customer-header-info d-flex align-items-center flex-wrap">
                        <small class="text-muted mr-1">Chi nhánh:</small>
                        <span class="mr-2">
                          <b>{{ bill.storeName }}</b>
                          <span
                            class="ml-1 text-muted"
                            v-if="bill.companyName"
                            style="font-size: 10px"
                            >( {{ bill.companyName }} )</span
                          >
                        </span>
                        <span :class="getBillTypeBadge(bill.type).class" style="font-size: 10px; padding: 2px 6px;">
                          {{ getBillTypeBadge(bill.type).text }}
                        </span>
                      </div>
                      <div class="d-flex bill-header-meta flex-wrap">
                        <span class="mr-4">
                          <small class="text-muted">Ngày tạo: </small>
                          <span class="text-primary">{{ bill.createdAt }}</span>
                        </span>
                        <span class="mr-4">
                          <small class="text-muted">TVBH:</small>
                          <span v-if="bill.saleName" class="text-dark">{{ bill.saleName }}</span>
                          <span v-else class="text-danger"> Chưa được gán </span>
                        </span>
                        <span class="mr-4">
                          <small class="text-muted">NVTN:</small>
                          <span v-if="bill.cashierName" class="text-dark">{{ bill.cashierName }}</span>
                          <span v-else class="text-danger"> Chưa được gán </span>
                        </span>
                        <span class="mr-4">
                          <small class="text-muted">NVKT:</small>
                          <span v-if="bill.technicalName" class="text-dark">{{ bill.technicalName }}</span>
                          <span v-else class="text-danger"> Chưa được gán </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
                <td style="border-bottom: none !important" colspan="2">
                  <b-row>
                    <b-col cols="10">
                      <div class="d-flex bill-header-meta">
                        <span v-if="bill.couponCode">
                          Mã coupon: {{ bill.couponCode }}
                        </span>
                      </div>
                    </b-col>
                    <b-col cols="2" class="text-right">
                      <i
                        class="fa fa-arrow-circle-o-down"
                        aria-hidden="true"
                      ></i>
                    </b-col>
                  </b-row>
                </td>
              </tr>
              <template v-for="(billItem, j) in bill.listProduct">
                <tr
                  v-if="j < limitListProduct"
                  :key="'p-' + bill.id + '-' + billItem.id + '-' + j"
                  @mouseenter="hoveredBillId = bill.id"
                  @mouseleave="hoveredBillId = null"
                  :class="{ 'tr-rowspan-hover': hoveredBillId === bill.id }"
                  :data="`row_${bill.billNumber}`"
                >
                  <td
                    :rowspan="
                      bill.listProduct.length > limitListProduct
                        ? limitListProduct
                        : bill.listProduct.length
                    "
                    v-if="j === 0 || bill.show"
                    class="tdTextAlign tdCode"
                  >
                    <div class="text-center mb-2">
                      <span
                        title="Từ app mobile"
                        v-b-tooltip
                        v-if="bill.deviceType === 2"
                      >
                        <i class="fas fa-mobile-alt text-dark ml-1"></i>
                      </span>
                      <span
                        title="Từ web"
                        v-b-tooltip
                        v-else-if="bill.deviceType === 1"
                      >
                        <i class="fas fa-globe-asia text-dark"></i>
                      </span>
                      <span title="Chưa xác định" v-b-tooltip v-else>
                        <i
                          class="fa fa-stop-circle text-danger"
                          aria-hidden="true"
                        ></i>
                      </span>
                    </div>
                    <div
                      class="orderCode"
                      style="cursor: pointer; color: #3699ff"
                    >
                      <a
                        class="font-weight-bold"
                        :href="getBillLink(bill)"
                        target="_self"
                      >
                        {{ bill.billNumber }}
                      </a>
                    </div>
                  </td>
                  <td class="tdTextAlign tdProductName">
                    <div v-if="billItem.typeProduct !== 3">
                      <div class="d-flex align-items-center flex-gap-8">
                        <ProductImage
                          :src="billItem.imageUrl"
                          class="size-40 object-contain flex-shrink-0"
                        />
                        <div class="product-info flex-grow-1 min-w-0">
                          <div class="product-codes">
                            <span v-if="billItem.barCode" class="code-text">
                              {{ billItem.barCode }}
                            </span>
                            <br />
                            <span v-if="billItem.productCode" class="code-text">
                              ({{ billItem.productCode }})
                            </span>
                          </div>
                          <div class="product-title">
                            <i
                              v-if="billItem.productType === 2"
                              class="fas fa-gift product-icon gift"
                              title="Quà tặng"
                            ></i>
                            <i
                              v-else-if="billItem.productType === 3"
                              class="fas fa-tags product-icon attach"
                              title="Bán kèm"
                            ></i>
                            <span class="product-name">{{
                              billItem.productName
                            }}</span>
                          </div>
                          <div
                            v-if="
                              billItem.imeiCode &&
                              billItem.imeiCode.trim() !== ''
                            "
                            class="product-meta"
                          >
                            <ImeiDisplay :imei="billItem.imeiCode" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div
                        class="table-responsive"
                        v-show="
                          billItem.comboItems && billItem.comboItems.length > 0
                        "
                      >
                        <table>
                          <tr>
                            <td style="border: none; padding-left: 0">
                              <p class="m-0">
                                {{ billItem.productName }}
                              </p>
                            </td>
                          </tr>
                          <tr
                            v-for="(items, comboIdx) in billItem.comboItems"
                            :key="comboIdx"
                            style="border-top: 1px solid gray"
                          >
                            <td
                              style="
                                border: none;
                                width: -webkit-fill-available;
                              "
                            >
                              <i
                                style="color: rgb(24, 28, 50)"
                                class="fas fa-cube"
                              ></i>
                              {{ items.productName }}
                              <i style="font-size: unset; color: unset"
                                >({{ convertPrice(items.sellingPrice) }})</i
                              >
                            </td>
                            <td style="border: none; font-size: 13px">
                              {{ items.quantity }}
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </td>
                  <td class="tdTextAlignPrice tdProductPrice">
                    {{ convertPrice(billItem.productPrice) }}
                  </td>
                  <td class="tdTextAlignPrice tdQuantity">
                    {{ billItem.quantity }}
                  </td>
                  <td class="tdTextAlignPrice tdDiscountItem">
                    <p v-if="billItem.discountType === 1">
                      {{ convertPrice(billItem.discount) }}
                    </p>
                    <p
                      v-if="
                        billItem.discountType === 2 && billItem.discount > 0
                      "
                    >
                      {{ convertPrice(billItem.discount) }}%
                      <br />
                      <span style="color: #ffa800; font-style: italic">
                        {{ convertPrice(billItem.discountItemAmount) }}</span
                      >
                    </p>
                    <p
                      v-if="
                        billItem.discountType === 2 && billItem.discount === 0
                      "
                    >
                      {{ convertPrice(billItem.discount) }}
                    </p>
                  </td>
                  <td
                    class="tdTextAlignPrice tdTotalAmount"
                    :rowspan="
                      bill.listProduct.length > limitListProduct
                        ? limitListProduct
                        : bill.listProduct.length
                    "
                    v-if="j === 0 || bill.show"
                  >
                    <p v-show="bill.shippingFee > 0" class="border-0">
                      <i
                        v-b-tooltip.hover
                        title="Phí ship"
                        class="fas fa-shipping-fast icon-color"
                      ></i>
                      : {{ convertPrice(bill.shippingFee) }}
                    </p>
                    <p v-show="bill.refundFee > 0" class="border-0">
                      <img
                        v-b-tooltip.hover
                        title="Phí trả hàng"
                        src="/media/svg/icons/Shopping/Dollar.svg"
                        class="icon-color mr-1"
                        alt="Phí trả hàng"
                        width="16"
                        height="16"
                      />
                      : {{ convertPrice(bill.refundFee) }}
                    </p>
                    <p v-show="bill.discountAmountStr" class="border-0 text-warning">
                      <i
                        v-b-tooltip.hover
                        title="Chiết khấu tổng"
                        class="fa fa-arrow-down icon-color"
                      ></i>
                      : {{ bill.discountAmountStr }}
                    </p>
                    <b style="color: #3c763d">
                      {{ convertPrice(bill.totalAmount) }}</b
                    >
                  </td>
                  <td
                    class="tdTextAlignPrice tdTotalPayment"
                    :rowspan="
                      bill.listProduct.length > limitListProduct
                        ? limitListProduct
                        : bill.listProduct.length
                    "
                    v-if="j === 0 || bill.show"
                  >
                    <p v-show="bill.pointToMoney > 0" class="border-0">
                      <i
                        v-b-tooltip.hover
                        title="Tiêu điểm"
                        class="fas fa-adjust icon-color"
                      ></i>
                      : {{ convertPrice(bill.pointToMoney) }}
                    </p>
                    <template v-if="bill.payments && bill.payments.length">
                      <div
                        v-for="(payment, pIdx) in bill.payments"
                        :key="pIdx"
                        class="mb-2"
                      >
                        <span class="mr-2">
                          <i
                            v-b-tooltip.hover
                            :title="payment.paymentName"
                            class="icon-color text-dark mr-1"
                            :class="
                              payment.paymentType === 1
                                ? 'fas fa-money-bill-alt'
                                : payment.paymentType === 2
                                  ? 'fa fa-university'
                                  : payment.paymentType === 3
                                    ? 'fa fa-credit-card'
                                    : payment.paymentType === 4
                                      ? 'fa fa-cube'
                                      : ''
                            "
                          ></i
                          >:
                        </span>
                        <span style="font-weight: 700">{{
                          convertPrice(payment.paymentAmount)
                        }}</span>
                      </div>
                    </template>
                    <p v-show="bill.conversionFee > 0" class="border-0">
                      <i
                        v-b-tooltip.hover
                        title="Thanh toán phí chuyển đổi"
                        class="fa-solid fa-money-bill-transfer icon-color text-dark"
                      ></i>
                      : {{ convertPrice(bill.conversionFee) }}
                    </p>
                    <p
                      v-if="bill.extraAmount > 0"
                      class="d-block text-primary"
                    >
                      Tiền thừa:
                      <span class="d-block">{{
                        convertPrice(bill.extraAmount)
                      }}</span>
                    </p>
                    <p
                      v-if="bill.extraAmount < 0"
                      class="d-block"
                      style="color: #e65b5b"
                    >
                      Còn thiếu:
                      <span class="d-block">
                        {{ convertPrice(bill.extraAmount * -1) }}</span
                      >
                    </p>
                    <p v-show="bill.leftAmount > 0">
                      Công nợ:
                      <span class="d-block">
                        {{ convertPrice(bill.leftAmount) }}</span
                      >
                    </p>
                  </td>
                  <td
                    class="tdTextAlign tdNote wrapword"
                    :rowspan="
                      bill.listProduct.length > limitListProduct
                        ? limitListProduct
                        : bill.listProduct.length
                    "
                    v-if="j === 0 || bill.show"
                  >
                    <p
                      v-if="bill.customerNote"
                      :title="bill.customerNote"
                      v-b-tooltip.hover
                    >
                      {{ truncateText(bill.customerNote) }}
                    </p>
                    <p
                      v-if="bill.customerNote && bill.warrantyNote"
                      class="dashed"
                    ></p>
                    <p
                      v-if="bill.warrantyNote"
                      :title="bill.warrantyNote"
                      v-b-tooltip.hover
                    >
                      {{ truncateText(bill.warrantyNote) }}
                    </p>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
          <tbody v-else-if="isLoading">
            <tr>
              <td colspan="8" class="text-center p-5">
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-2">Đang tải...</strong>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="8" class="text-center text-muted p-5">
                Không có hóa đơn nào
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-between align-items-center mt-3">
        <p class="text-muted mb-0">
          Tổng số: <strong>{{ totalItems }}</strong> hóa đơn
        </p>
        <b-pagination
          v-if="totalPages > 1"
          v-model="currentPage"
          :total-rows="totalItems"
          :per-page="10"
          align="right"
          size="sm"
          class="custom-pagination"
          @change="onPageChange"
        ></b-pagination>
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue';
import ApiService from '@/core/services/api.service';
import { convertPrice, truncateText } from '@/utils/common';
import ProductImage from '@/view/components/products/ProductImage.vue';
import ImeiDisplay from '@/view/components/imeis/ImeiDisplay.vue';
import datePicker from 'vue-bootstrap-datetimepicker';
import moment from 'moment';
import useCustomerHistory from '../composables/useCustomerHistory';

export default defineComponent({
  name: 'CustomerBillHistoryTab',

  components: {
    ProductImage,
    ImeiDisplay,
    datePicker,
  },

  props: {
    customerId: {
      type: [String, Number],
      required: true,
    },
    customerPhone: {
      type: String,
      default: '',
    },
    customerName: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    const limitListProduct = 10;
    const hoveredBillId = ref(null);

    const filters = ref({
      fromDate: null,
      toDate: null,
      type: 'all',
    });

    const datePickerConfig = {
      format: 'DD/MM/YYYY',
      useCurrent: false,
      showClear: true,
      showClose: true,
      locale: 'vi',
    };

    const billTypeOptions = [
      { value: 'all', text: 'Tất cả' },
      { value: 1, text: 'Hóa đơn bán lẻ' },
      { value: 2, text: 'Hóa đơn bán buôn' },
      { value: 3, text: 'Hóa đơn trả hàng' },
      { value: 4, text: 'Hóa đơn giao hàng' },
    ];

    const getBillLink = (bill) => {
      if (bill.type === 2) {
        return `#/wholesale-invoice/update-wholesale-invoice?id=${bill.billNumber}`;
      } else if (bill.type === 4) {
        return `#/delivery-bills/update-delivery-bill?id=${bill.billNumber}`;
      } else if (bill.type === 3) {
        return `#/refund-bills/update-refund-bill?billNumber=${bill.billNumber}`;
      } else {
        return `#/bills/update-bill?id=${bill.billNumber}`;
      }
    };

    const loadBills = async (page) => {
      const params = {
        page,
        limit: 10,
        customerId: Number(props.customerId),
        type: filters.value.type,
      };

      if (filters.value.fromDate) {
        params.fromDate = moment(filters.value.fromDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
      if (filters.value.toDate) {
        params.toDate = moment(filters.value.toDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }

      const response = await ApiService.query('v1/bills', { params });
      const data = response.data.data || {};
      const dataset = data.dataset || [];

      const mappedItems = dataset.map((item) => {
        let discountAmount = '';
        if (item.discountType === 2) {
          discountAmount = item.discountAmount + '%';
        } else if (item.discountType === 1) {
          discountAmount = convertPrice(item.discountAmount) + '';
        }
        return {
          ...item,
          discountAmountStr: discountAmount,
          show: (item.listProduct || []).length <= 0,
          showDetail: false,
          listProduct: item.listProduct || [],
        };
      });

      return {
        items: mappedItems,
        totalRow: data.totalRow || 0,
        totalPage: data.totalPage || 0,
      };
    };

    const {
      items,
      totalItems,
      totalPages,
      currentPage,
      isLoading,
      fetchPage,
      onPageChange,
    } = useCustomerHistory(loadBills);

    const onApplyFilter = () => {
      fetchPage(1);
    };

    const onResetFilter = () => {
      filters.value.fromDate = null;
      filters.value.toDate = null;
      filters.value.type = 'all';
      fetchPage(1);
    };

    const getBillTypeBadge = (type) => {
      switch (type) {
        case 1:
          return { class: 'badge badge-success text-white', text: 'Bán lẻ' };
        case 2:
          return { class: 'badge badge-warning text-white', text: 'Bán buôn' };
        case 3:
          return { class: 'badge badge-danger text-white', text: 'Trả hàng' };
        case 4:
          return { class: 'badge badge-primary text-white', text: 'Giao hàng' };
        default:
          return { class: 'badge badge-secondary text-white', text: 'Hóa đơn' };
      }
    };

    onMounted(() => {
      if (props.customerPhone || props.customerName) {
        fetchPage(1);
      }
    });

    return {
      items,
      totalItems,
      totalPages,
      currentPage,
      isLoading,
      onPageChange,
      convertPrice,
      truncateText,
      limitListProduct,
      hoveredBillId,
      getBillLink,
      filters,
      datePickerConfig,
      billTypeOptions,
      getBillTypeBadge,
      onApplyFilter,
      onResetFilter,
    };
  },
});
</script>

<style scoped>
.customer-history {
  padding: 1rem 0;
}

.orderCode:hover {
  text-decoration: underline;
}

.table th,
.table td {
  vertical-align: middle;
}

.tdTextAlign {
  vertical-align: middle;
}

.tdTextAlignPrice {
  text-align: right !important;
  vertical-align: middle;
}

.table-bordered-list th {
  border: 0.5px solid #d2d4d6 !important;
  background-color: #e0e0e0;
}

.table-bordered-list td {
  border: 0.5px solid #f3f3f3;
  border-bottom: 0.5px solid #adadad;
}

.text-weight {
  font-weight: 550;
}

.tdCode {
  width: 5%;
}

.tdProductName {
  width: 38%;
}

.tdProductPrice {
  width: 8%;
}

.tdQuantity {
  width: 3%;
}

.tdDiscountItem {
  width: 5%;
}

.tdTotalAmount {
  width: 8%;
}

.tdTotalPayment {
  width: 12%;
  font-weight: 700;
}

.tdNote {
  width: 8%;
}

.flex-gap-8 {
  gap: 8px;
}

.size-40 {
  width: 40px;
  height: 40px;
}
</style>

<style lang="scss" scoped>
.customer-history ::v-deep {
  .bill-header-meta {
    font-size: 0.87rem;
  }

  .customer-header-info {
    margin-bottom: 2px;
    font-size: 0.87rem;
    line-height: 1.35;

    > small.text-muted {
      margin-right: 4px;
    }
  }

  .dashed {
    border: 1px dashed #464e5f;
    border-style: none none dashed;
    color: #fff;
    background-color: #fff;
  }

  .product-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .product-codes {
    font-size: 12px;
    color: #475569;
    font-weight: 500;
  }

  .code-text {
    margin-right: 4px;
  }

  .product-title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    color: #111827;
  }

  .product-icon {
    margin-right: 6px;
    font-size: 14px;
  }

  .product-icon.gift {
    color: #2e7d32;
  }

  .product-icon.attach {
    color: #37474f;
  }

  .product-name {
    font-size: 14px;
  }

  .product-meta {
    margin-left: 2px;
    margin-top: 2px;
  }

  .tdNote {
    width: 8%;
    font-size: 0.8125rem;
  }
}
</style>
